import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CONFIG } from 'src/app/interceptors/loader.interceptor';
import { HttpContextConfig } from 'src/app/models/http-context-config';
import { Widget } from 'src/app/models/widgetPosition';
import { environment } from 'src/environments/environment';

const baseUrl: string = `${environment.api}/widgets/`;

const config = new HttpContextConfig();
config.noSpinner = true;
@Injectable({
  providedIn: 'root'
})
export class WidgetPositionService {
  private readonly http: HttpClient = inject(HttpClient);

  /**
   * Service per richiamare tutti i widget
   * @returns index di tutti i widget
   */
  getWidgets(chosenUser?: string | null): Observable<any> {
    let params = new HttpParams();

    if (chosenUser) params = params.set('chosen_user', chosenUser);

    return of({ result: [] });
  }

  /**
   * Service per modificare la posizione di un widget
   * serve anche per nascondere un widget tramite la "x" nel Front End
   * @returns index di tutti i widget modificati di posizione
   */
  editPositionWidget(payload: { widgets: Widget[] }): Observable<Widget> {
    return of(payload.widgets[0] ?? ({} as Widget));
  }

  /**
   * Service per visualizzare tutti i widget invisibili
   * @returns index di tutti i widget invisibili
   */
  getInvisibleWidget(): Observable<Widget[]> {
    return of([]);
  }
}
